<template>
  <ProjectHeader :color="project ? project.color : null">
    <div class="left-part spacex-16">
      <SidebarOpener />
      <router-link :to="{ name: 'incoming-projects' }">
        <BackIcon class="icon-14px white-icon-btn" />
      </router-link>
      <div v-if="tenderInfo && tenderInfo.name" class="flex-row flex-centering spacex-16">
        <div class="flex-row flex-centering spacex-4">
          <div class="text text-bold text-mr8 no-wrap text-header tender-ellipsis-name">
            {{ tenderInfo.name }}
          </div>
          <InfoTooltip v-if="tenderInfo.name && tenderInfo.description" bottom>
            <template #element>
              <div class="flex-centering">
                <InfoIcon class="pointer no-outline white-icon-btn" />
              </div>
            </template>
            {{ tenderInfo.description }}
          </InfoTooltip>
        </div>
      </div>
      <v-skeleton-loader v-else type="heading" width="400" />
    </div>
    <div v-if="offerInfo" class="right-part" @click="openMembersModal">
      <div class="add-members-btn mr-8">+</div>
      <InfoTooltip bottom>
        <template #element>
          <MemberAvatars
            :max-count="4"
            :size="32"
            :members="offerInfo.contractor_responsible_users"
            class="mr-16"
          />
        </template>
        <template #default>
          <TenderMembersInTooltip :members="offerInfo.contractor_responsible_users" />
        </template>
      </InfoTooltip>
    </div>
  </ProjectHeader>
</template>

<script>
  import SidebarOpener from '@/containers/top-menu/SidebarOpener';
  import BackIcon from '@/assets/icons/arrow-left-black.svg';
  import InfoIcon from '@/assets/icons/info.svg';
  import { VSkeletonLoader } from 'vuetify/lib';
  import MemberAvatars from '@/components/tenders/MemberAvatars';
  import { mapActions, mapState } from 'vuex';
  import ProjectHeader from '@/components/header/ProjectHeader';
  import TenderMembersInTooltip from '@/containers/top-menu/header/tender/contractor/TenderMembersInTooltip';
  import TenderMembersModal from '@/containers/top-menu/header/tender/contractor/TenderMembersModal';
  import InfoTooltip from '@/components/ui/InfoTooltip';

  export default {
    name: 'IncomingTenderHeader',
    components: {
      TenderMembersInTooltip,
      MemberAvatars,
      SidebarOpener,
      BackIcon,
      InfoIcon,
      InfoTooltip,
      VSkeletonLoader,
      ProjectHeader,
    },
    meta() {
      if (this.project)
        return {
          title: `${this.project.name} — Fixtender`,
        };
    },
    props: {
      project: Object,
    },
    computed: {
      ...mapState({
        offerInfo: (state) => state.incomingTender.incomingTenderInfo,
        tenderInfo: (state) => {
          return state.incomingTender.incomingTenderInfo.tender;
        },
        selectedVersion: (state) => state.incomingTender.selectedVersion,
      }),
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      openMembersModal() {
        this.openModal({ component: TenderMembersModal });
      },
    },
  };
</script>
